import { createRouter, createWebHistory } from 'vue-router'
import authMiddleware from '../middleware/auth.js'
import { useAuthStore } from '../stores/auth.js'


const routes = [
  
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { 
      showNav: true,
      requiresAuth: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/patients',
    name: 'Patients',
    component: () => import('../views/Patients.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/patients/:id',
    name: 'PatientDetail',
    component: () => import('../views/PatientDetail.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
      path: '/vitals',
      name: 'Vitals',
      component: () => import('../views/Vitals.vue'),
      meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/client-vitals',
    name: 'ClientVitals',
    component: () => import('../views/client/ClientVitals.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
      path: '/view-vitals',
      name: 'ViewVitals',
      component: () => import('../views/client/ViewVitals.vue'),
      meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/view_history',
    name: 'ViewHistory',
    component: () => import('../views/ViewHistory.vue'),
    meta: { showNav: true, requiresAuth: true }
  },  
  {
    path: '/client-history',
    name: 'ClientHistory',
    component: () => import('../views/client/ClientHistory.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/medications',
    name: 'Medications',
    component: () => import('../views/Medications.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import('../views/Tasks.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Reports.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { showNav: true, requiresAuth: true }
  },
  {
    path: '/',
    name: 'Startup',
    component: () => import('../views/Startup.vue'),
    meta: { guest: true, title: 'Startup' }
  },
   {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('../views/Unauthorized.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true }
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  //const isAuthenticated = localStorage.getItem('access_token')
  const authStore = useAuthStore()
  if (to.matched.some(record => record.meta.requiresAuth) && !authStore.isAuthenticated) {
   
    return next({ name: 'Login' })
  }  if (to.matched.some(record => record.meta.guest) && authStore.isAuthenticated) {
    return next({ name: 'Dashboard' })
  } if(authStore.isAuthenticated  && (to.meta.roles || to.meta.permissions)) {
    const hasAccess = authMiddleware({
      roles: to.meta.roles || [],
      permissions: to.meta.permissions || []
    })

    if(!hasAccess) {
      return next({ name: 'unauthorized' })
    }
  }
  if(to.meta.title){
    document.title = `${to.meta.title} | HomeCare System`
  }
  next()
})

export default router